import React, { useState, useEffect, useRef } from 'react';

import styles from './LinkPopover.module.scss';

const LinkPopover = ({
  isOpen,
  onClose,
  onApply,
  onRemove,
  initialHref,
  children,
}) => {
  const [url, setUrl] = useState('');
  const inputRef = useRef(null);
  const popoverRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setUrl(initialHref || '');
      setTimeout(() => inputRef.current?.focus(), 0);
    }
  }, [isOpen, initialHref]);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  const handleApply = () => {
    const trimmed = url.trim();
    if (trimmed) {
      onApply(trimmed);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleApply();
    }
  };

  return (
    <div className={styles.wrapper} ref={popoverRef}>
      {children}
      {isOpen && (
        <div className={styles.popover}>
          <input
            ref={inputRef}
            className={styles.urlInput}
            type="text"
            placeholder="https://example.com"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button
            className={styles.applyButton}
            onClick={handleApply}
            type="button"
          >
            Apply
          </button>
          {initialHref && (
            <button
              className={styles.removeButton}
              onClick={onRemove}
              type="button"
            >
              Remove
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default LinkPopover;
